/**
 * ThreadListNotice — the in-list notice after an organization change
 * (2026-09-09): "moved to clients · undo". Polite, transient (the host's
 * timer), undo in place. Chrome copy only (D9).
 */
import React from 'react';
import { RailNotice, RailNoticeAction } from './organizeStyles';
import { threadListCopy } from './threadListCopy';
import type { ThreadListLang } from '../../types/threadCategories';
import type { ThreadListNoticeState } from './threadOrganize';

export interface ThreadListNoticeProps {
  notice: ThreadListNoticeState | null;
  lang: ThreadListLang;
  onDismiss: () => void;
  /**
   * 'toast' pins it above the rail's footer instead of letting it sit in the
   * list's flow (2026-09-20). In flow it pushed every row down as it appeared,
   * and on a long list it rendered below the fold — invisible to the person it
   * was offering the undo to. The sheet keeps 'flow'.
   */
  placement?: 'flow' | 'toast';
}

export const ThreadListNotice: React.FC<ThreadListNoticeProps> = ({ notice, lang, onDismiss, placement = 'flow' }) => {
  const copy = threadListCopy(lang);
  return (
    <div role="status" aria-live="polite" data-thread-list-notice-region="">
      {notice && (
        <RailNotice $placement={placement} data-thread-list-notice={notice.id} data-notice-placement={placement}>
          <span>{notice.text}</span>
          {notice.undo && (
            <RailNoticeAction type="button" data-thread-list-notice-undo="" onClick={() => { notice.undo?.(); onDismiss(); }}>
              {copy.undo}
            </RailNoticeAction>
          )}
        </RailNotice>
      )}
    </div>
  );
};

export default ThreadListNotice;
